// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getLabelValue, getIconPath } from '@tcp/core/src/utils/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from './styles/MyPreferenceAppSubscribeModal.style';
import MyPreferenceSubscriptionConstants from '../../MyPreferenceSubscription.constants';
import MyPreferenceSubscriptionLabels, {
  ACCOUNT_PREFERENCES,
} from '../../views/MyPreferenceSubscription.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblCancel,
  lblSubmit,
} from '../../../../../../utils/labels/globalActions.labels';

/**
 * This Class component use for return the My Preference Subscribe Modal
 * can be passed in the component.
 * @param MyPreferenceAppSubscribeModal - is a  functional component we can use it within  any component
 * * @param onRequestClose - received onRequestClose function as param for closed popup
 * * @param onSubmit - received onSubmit function to handle form data
 */
class MyPreferenceAppSubscribeModal extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onRequestClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    activeModal: PropTypes.string.isRequired,
    labels: PropTypes.shape({}),
  };

  static defaultProps = {
    className: '',
    labels: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      pushNotificationDownloadText: '',
      pushNotificationAppleDownloadText: '',
      pushNotificationGooglePlayDownloadText: '',
    };
    this.myPreferenceLabels = getLabelFromCopyOrFromTranslation(
      ACCOUNT_PREFERENCES,
      MyPreferenceSubscriptionLabels
    );
  }

  componentDidMount() {
    const { activeModal } = this.props;
    const tcpSubscribed = activeModal === MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE;
    const gymSubscribed = activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE;
    const snjSubscribed = activeModal === MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE;
    const pjpSubscribed = activeModal === MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE;

    let pushNotificationDownload;
    let pushNotificationAppleDownload;
    let pushNotificationGooglePlayDownload;
    if (tcpSubscribed) {
      pushNotificationDownload = renderLabel(
        this.myPreferenceLabels?.lbl_preference_push_notification_Tcp_download,
        'lbl_preference_push_notification_Tcp_download'
      );
      pushNotificationAppleDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_tcp_applestore'
      );

      pushNotificationGooglePlayDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_tcp_googleplay'
      );
    } else if (gymSubscribed) {
      pushNotificationDownload = renderLabel(
        this.myPreferenceLabels?.lbl_preference_push_notification_Gymboree_download,
        'lbl_preference_push_notification_Gymboree_download'
      );
      pushNotificationAppleDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_gym_applestore'
      );

      pushNotificationGooglePlayDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_gym_googleplay'
      );
    } else if (snjSubscribed) {
      pushNotificationDownload = renderLabel(
        this.myPreferenceLabels?.lbl_preference_push_notification_snj_download,
        'lbl_preference_push_notification_snj_download'
      );
      pushNotificationAppleDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_snj_applestore'
      );

      pushNotificationGooglePlayDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_snj_googleplay'
      );
    } else if (pjpSubscribed) {
      pushNotificationDownload = renderLabel(
        this.myPreferenceLabels?.lbl_preference_push_notification_pjp_download,
        'lbl_preference_push_notification_pjp_download'
      );
      pushNotificationAppleDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_pjp_applestore'
      );

      pushNotificationGooglePlayDownload = getDynamicLabelValues(
        'dynamic.account_d.lbl_preference_push_notification_pjp_googleplay'
      );
    }
    this.setState({
      pushNotificationDownloadText: pushNotificationDownload,
      pushNotificationAppleDownloadText: pushNotificationAppleDownload,
      pushNotificationGooglePlayDownloadText: pushNotificationGooglePlayDownload,
    });
  }

  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */

  render() {
    const { className, onSubmit, onRequestClose, labels } = this.props;
    const {
      pushNotificationDownloadText,
      pushNotificationAppleDownloadText,
      pushNotificationGooglePlayDownloadText,
    } = this.state;

    return (
      <div className={className}>
        <BodyCopy component="div" className="myPreferenceModalWrapper">
          <BodyCopy
            fontSize="fs22"
            fontWeight="extrabold"
            fontFamily="secondary"
            textAlign="center"
            className="elem-mb-MED elem-mt-LRG"
            data-locator="my-preference-web-push_title"
          >
            {renderLabel(
              this.myPreferenceLabels?.lbl_preference_push_notification_heading,
              'lbl_preference_push_notification_heading'
            )}
          </BodyCopy>
          <BodyCopy
            component="div"
            fontSize="fs14"
            fontFamily="secondary"
            textAlign="center"
            className="elem-mb-LRG"
            data-locator="my-preference-web-push_subtext"
          >
            {renderLabel(
              this.myPreferenceLabels?.lbl_preference_push_notification_subtext,
              'lbl_preference_push_notification_subtext'
            )}
          </BodyCopy>
          <BodyCopy
            component="div"
            fontSize="fs14"
            fontFamily="secondary"
            textAlign="center"
            className="elem-mb-MED"
            fontWeight="extrabold"
            data-locator="my-preference--web-push_download"
          >
            {pushNotificationDownloadText}
          </BodyCopy>

          <Row fullBleed className="elem-mb-LRG">
            <Col colSize={{ small: 3, medium: 4, large: 6 }}>
              <Anchor
                href={`${pushNotificationAppleDownloadText}`}
                className="elem-ml-SM"
                data-locator="my-preference-modal_app_store"
                target="_blank"
              >
                <Image
                  class="elem-pl-XS"
                  src={getIconPath('app-store')}
                  alt={getLabelValue(labels, 'appStoreLabel')} // TO DO - this label does not exist
                />
              </Anchor>
            </Col>
            <Col colSize={{ small: 3, medium: 4, large: 6 }}>
              <Anchor
                href={`${pushNotificationGooglePlayDownloadText}`}
                className="elem-ml-SM"
                target="_blank"
                data-locator="my-preference-modal_google_play"
              >
                <Image
                  class="elem-pl-XS"
                  src={getIconPath('google-play')}
                  alt={getLabelValue(labels, 'playStoreLabel')} // TO DO - this label does not exist
                />
              </Anchor>
            </Col>
          </Row>

          <BodyCopy
            component="div"
            fontSize="fs14"
            fontFamily="secondary"
            textAlign="center"
            className="layout-pb-LRG"
            data-locator="my-preference-web-push_note"
          >
            {renderLabel(
              this.myPreferenceLabels?.lbl_preference_push_notification_note,
              'lbl_preference_push_notification_note'
            )}
          </BodyCopy>

          <Row fullBleed className="elem-mb-LRG">
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <Button
                fullWidth
                buttonVariation="fixed-width"
                fill="BLUE"
                type="submit"
                className="submit-button"
                dataLocator="subscribe-web-push_submit"
                onClick={onSubmit}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblSubmit}`,
                    GlobalActionsLabels
                  ),
                  'lbl_submit'
                )}
              </Button>
            </Col>
          </Row>
          <Row fullBleed className="elem-mb-LRG">
            <Col colSize={{ small: 6, medium: 8, large: 12 }}>
              <Button
                fullWidth
                buttonVariation="fixed-width"
                fill="WHITE"
                className="cancel-button"
                dataLocator="subscribe-web-push_cancel"
                onClick={onRequestClose}
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblCancel}`,
                    GlobalActionsLabels
                  ),
                  'lbl_cancel'
                )}
              </Button>
            </Col>
          </Row>
        </BodyCopy>
      </div>
    );
  }
}

export default withStyles(MyPreferenceAppSubscribeModal, styles);
export { MyPreferenceAppSubscribeModal as MyPreferenceAppSubscribeModalVanilla };
